import {
  FontWeights,
  HeadingLevels,
  OnlyForScreenReader,
  StandardHeading,
  StandardLink,
  StandardText
} from '@brandfolder/react';
import React, { FunctionComponent, useEffect, useState } from 'react';

import { knowledgeBaseHomepageLink } from '@components/kb-article-links';

import { UserGroupsForm } from './UserGroupsForm';
import { UserGroupsList } from './UserGroupsList';

import classes from './styles/user-groups.module.scss';

interface UserGroupsCreateProps {
  organizationKey: string;
}

export const UserGroupsCreate: FunctionComponent<UserGroupsCreateProps> = (props) => {
  const { organizationKey } = props;

  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    if (refetch) {
      setRefetch(false);
    }
  }, [refetch]);

  return (
    <div className={classes.userGroups}>
      <section>
        <StandardHeading
          className={classes.title}
          level={HeadingLevels.h2}
          weight={FontWeights.Book}
        >
          {bfTranslate('User Groups')}
        </StandardHeading>
        <StandardText
          className={classes.text}
        >
          {bfTranslate('User groups allow you to easily manage users in bulk. Name your group, add email addresses, and you’re all set to manage roles and access for everyone on your team.')}
          &nbsp;
          <StandardLink
            className={classes.link}
            href={knowledgeBaseHomepageLink}
            rel="noopener noreferrer"
            target="_blank"
          >
            {bfTranslate('Get the details in our Knowledge Base.')}
            <OnlyForScreenReader>{bfTranslate('Opens in a new tab.')}</OnlyForScreenReader>
          </StandardLink>
        </StandardText>
      </section>
      <UserGroupsForm organizationKey={organizationKey} setRefetch={setRefetch} />
      <UserGroupsList refetch={refetch} />
    </div>
  );
};
